var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-header info-head" },
    [
      (_vm.brand_white1 || _vm.brand_translux5) &&
      _vm.screenConfiguration.is2showsingleevent &&
      _vm.liveEventAppearsOnScreen
        ? _c("span", { staticClass: "live-icon" }, [_vm._v("LIVE")])
        : _vm._e(),
      _vm._v(" "),
      _vm.showparticipantlogo && (_vm.brand_white1 || _vm.brand_translux5)
        ? _c("sport-icon", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "sport-name text-overflow" }, [
        _c("span", { staticClass: "text-overflow" }, [
          _vm._v(_vm._s(_vm.event.fosporttypename || _vm.event.idfosporttype))
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "team-name text-overflow" }, [
        _c("span", { staticClass: "text-overflow" }, [
          _vm._v(_vm._s(_vm.event.eventname))
        ])
      ]),
      _vm._v(" "),
      (_vm.brand_white1 || _vm.brand_translux5) &&
      _vm.event.half === 0 &&
      _vm.currentRotateIndex !== undefined &&
      _vm.maxRotationIndex !== undefined
        ? _c("span", { staticClass: "paging-index" }, [
            _vm._v(
              "PAGE " +
                _vm._s(_vm.currentRotateIndex + 1) +
                " of " +
                _vm._s(_vm.maxRotationIndex + 1)
            )
          ])
        : (_vm.brand_white1 || _vm.brand_translux5) &&
          _vm.event.half === 1 &&
          _vm.currentRotateIndex1 !== undefined &&
          _vm.maxRotationIndex1 !== undefined
        ? _c("span", { staticClass: "paging-index" }, [
            _vm._v(
              "PAGE " +
                _vm._s(_vm.currentRotateIndex1 + 1) +
                " of " +
                _vm._s(_vm.maxRotationIndex1 + 1)
            )
          ])
        : _c("span", { staticClass: "paging-index" }, [
            _vm._v(
              "PAGE " +
                _vm._s(_vm.currentRotateIndex + 1) +
                " of " +
                _vm._s(_vm.maxRotationIndex + 1)
            )
          ]),
      _vm._v(" "),
      (_vm.brand_white1 || _vm.brand_translux5) && !_vm.brand_ultrawide
        ? _c("div", { staticClass: "clock" }, [
            _vm.brand_white1 || _vm.brand_translux5
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.event.tsExpectedStart,
                          _vm.dateFormats.dayAndMonthInverse
                        )
                      ) +
                      "\n    "
                  )
                ])
              : _c("span", { staticClass: "date" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.event.tsExpectedStart,
                          _vm.dateFormats.dayAndMonth
                        )
                      ) +
                      "\n    "
                  )
                ]),
            _vm._v(" "),
            _c("span", { staticClass: "time" }, [
              _vm.event.idfobolifestate === "O"
                ? _c("span", [
                    _c("span", { staticClass: "hour" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(
                            _vm.event.tsExpectedStart,
                            _vm.dateFormats.shortTime
                          )
                        ) +
                          " " +
                          _vm._s(
                            _vm._f("moment")(_vm.event.tsExpectedStart, "A")
                          )
                      )
                    ])
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.$t("Finished")))])
            ])
          ])
        : _c("span", { staticClass: "time" }, [
            _vm.event.idfobolifestate === "O"
              ? _c("span", [
                  _vm.isDateToday
                    ? _c("span", { staticClass: "day" }, [_vm._v("Today")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDateTomorrow
                    ? _c("span", { staticClass: "day" }, [_vm._v("Tomorrow")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isDateToday && !_vm.isDateTomorrow
                    ? _c("span", { staticClass: "day long-date" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.event.tsExpectedStart,
                              _vm.dateFormats.longDate
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isDateToday && !_vm.isDateTomorrow
                    ? _c("span", { staticClass: "day day-month-reverse" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.event.tsExpectedStart,
                              _vm.dateFormats.dayAndMonthInverse
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "hour" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(
                          _vm.event.tsExpectedStart,
                          _vm.dateFormats.shortTime
                        )
                      ) +
                        " " +
                        _vm._s(_vm._f("moment")(_vm.event.tsExpectedStart, "A"))
                    )
                  ])
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("Finished")))])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6433d572", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6433d572","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/cduInfoHead.vue
// module id = null
// module chunks = 